Customer.Dashboard ||= {}

class Customer.Dashboard.CutTicketEventView extends Backbone.View
  template: JST['backbone/templates/customer/ticket/detail/visible_event_templates/ticket_cut_event']
  className: 'clearfix'
  viewType: 'ticket_event'
  events:
    'click .new_ticket_link': 'openNewTicket'


  initialize: (options = {}) ->
    @options = options

  viewSubType: ->
    @model.get('sub_type')

  render: ->
    _visible_event = @model.toJSON()
    _visible_event_text = @_visibleEventText(_visible_event)
    _target_text = " #{I18n.t("customer.dashboard.conversations.go_to_ticket")}"
    event_date = _visible_event.event_date
    event_date_locale = new Date(event_date)
    @$el.html(@template(event_text: _visible_event_text, event_date: event_date_locale, target_text: _target_text, ticket_id: _visible_event.ticket_id  ))
    @

  removeReplyButton: ->
# do nothing

  removeCutTicketButton: ->
# do nothing

  openNewTicket: (e) ->
    $('body').css('cursor', 'progress')
    @$el.find('.opening-ticket-button').show()
    ticket_id = $(e.target).attr('data-new-ticket-id')
    Backbone.trigger('interaction:go_to_case', ticket_id, @toggleCursor)

  toggleCursor: =>
    @$el.find('.opening-ticket-button').hide()
    $('body').css('cursor', 'default')

  _isLastOngoingSurveyInteraction: (model) ->
    false

  _visibleEventText: (event) =>
    if event.fields?.is_automatic_ticket_cut
      " #{I18n.t("customer.dashboard.conversations.automatic_ticket_cut")}"
    else
      " #{I18n.t("customer.dashboard.conversations.ticket_cut")}"
